import { CcfPopOver, useTranslator } from '@nice-ccf/ui-controls';
import { PopOverMenuItem } from '../../model/callControlPopover';

/* eslint-disable-next-line */
export interface CcfFetchInboundOutboundPopoverProps {
  initiateOutbound(): void;
  fetchInteraction(): void;
}

/**
 * Function is used to display popup component on assignemnt section
 * @param props -CcfFetchInboundOutboundPopoverProps
 * @returns Popup component displaying fetching interaction and initiate outbound options
 * ```
 * @example <CcfFetchInboundOutboundPopover initiateOutbound={outboundCallInitiate} fetchInteraction={fetchInteraction}/>
 * ```
 */
export function CcfFetchInboundOutboundPopover(
  props: CcfFetchInboundOutboundPopoverProps
) {
  const [translate] = useTranslator();
  const dropdownOptions = {
    menuItems: [
      {
        items: [
          {
            label: translate('requestInteraction'),
            closeOnSelection: true,
          },
          {
            label: translate('newOutbound'),
            closeOnSelection: true,
          },
        ],
      },
    ],
  };

  /**
   * Function is helps in calling function when button is clicked on popup
   * @param item -String
   * @returns Function
   * @example onPopOverItemSelections('fetchingInteractions')
   */
  const onPopOverItemSelection = (item: PopOverMenuItem) => () => {
    switch (item.label) {
      case translate('requestInteraction'):
        return props.fetchInteraction();
      case translate('newOutbound'):
        return props.initiateOutbound();
      default:
        return console.log('Please select correct option');
    }
  };

  return (
    <CcfPopOver
      onPopOverItemSelection={onPopOverItemSelection}
      optionList={dropdownOptions}
    />
  );
}

export default CcfFetchInboundOutboundPopover;
